export const SERVICES = [
  {
    slug: "stock-broker",
    code: "SB",
    title: "Stock Brokers",
    kicker: "Trading & Clearing Members",
    short: "Internal audits, exchange inspections and day-to-day compliance for trading and clearing members.",
    image: "/images/heritage.jpg",
    intro:
      "Stock brokers operate under one of the most closely supervised frameworks in Indian capital markets. We help trading and clearing members stay inspection-ready across exchanges, depositories and SEBI.",
    scope: [
      "Half-yearly internal audit by a Practising Company Secretary",
      "Exchange and SEBI inspection preparation and assistance",
      "Compliance calendar, periodic submissions and certifications",
      "Client funds & securities, margin and settlement process reviews",
      "PMLA / AML framework review and staff training",
      "Policies & procedures drafting and annual review",
    ],
  },
  {
    slug: "depository-participant",
    code: "DP",
    title: "Depository Participants",
    kicker: "NSDL & CDSL",
    short: "Concurrent and internal audits, account-opening and DIS process reviews for NSDL and CDSL participants.",
    image: "/images/signing.jpg",
    intro:
      "Depository Participants carry the custody of investor securities. We review your operations against depository bye-laws and SEBI requirements so that every account, instruction and record stands up to scrutiny.",
    scope: [
      "Concurrent audit and internal audit of DP operations",
      "Account opening, KYC and modification process checks",
      "Delivery Instruction Slip (DIS) and POA / DDPI controls",
      "Depository inspection support and response drafting",
      "Grievance redressal and record maintenance reviews",
      "Policy documentation and periodic reporting",
    ],
  },
  {
    slug: "research-analyst",
    code: "RA",
    title: "Research Analysts",
    kicker: "SEBI (RA) Regulations",
    short: "Registration support, disclosure frameworks and annual compliance audits for RAs.",
    image: "/images/pen.jpg",
    intro:
      "Research Analysts are held to strict standards of independence, disclosure and record-keeping. We help individual and corporate RAs register correctly and stay compliant thereafter.",
    scope: [
      "Registration application and documentation support",
      "Disclosure, conflict-of-interest and research report frameworks",
      "Annual compliance audit",
      "Client agreement and terms & conditions drafting",
      "Record maintenance and grievance mechanism setup",
      "Advisory on regulatory changes and circulars",
    ],
  },
  {
    slug: "investment-adviser",
    code: "IA",
    title: "Investment Advisers",
    kicker: "SEBI (IA) Regulations",
    short: "Registration, fee architecture, risk-profiling and annual audits for RIAs.",
    image: "/images/signing.jpg",
    intro:
      "From registration to the annual compliance audit, we help Investment Advisers build practices that are suitable, transparent and well documented.",
    scope: [
      "Registration readiness and application support",
      "Investment advisory agreement and fee structure review",
      "Risk profiling and suitability process documentation",
      "Annual compliance audit",
      "Segregation of advisory and distribution activities",
      "Ongoing regulatory updates and reporting",
    ],
  },
  {
    slug: "pms",
    code: "PMS",
    title: "Portfolio Managers",
    kicker: "SEBI (PM) Regulations",
    short: "Regulatory framework, disclosure documents, reporting and audit support for PMS.",
    image: "/images/bse.jpg",
    intro:
      "Portfolio Managers balance discretionary mandates with a demanding disclosure and reporting regime. We bring structure to your compliance function.",
    scope: [
      "Registration and documentation support",
      "Disclosure document and client agreement review",
      "Periodic reporting to SEBI and clients",
      "Compliance monitoring and internal reviews",
      "Inspection preparation and response support",
      "PMLA / AML and KYC framework review",
    ],
  },
  {
    slug: "aif",
    code: "AIF",
    title: "Alternative Investment Funds",
    kicker: "Category I, II & III",
    short: "Registration, PPM documentation, ongoing compliance and reporting for AIFs across categories.",
    image: "/images/skyline.jpg",
    intro:
      "Alternative Investment Funds operate across varied structures and strategies. We support managers and sponsors with registration, documentation and ongoing compliance through the life of the fund.",
    scope: [
      "Registration application and documentation support",
      "Private Placement Memorandum (PPM) compliance review",
      "Periodic reporting and regulatory filings",
      "Compliance test reports and audit support",
      "Investor onboarding, KYC and PMLA processes",
      "Secretarial and governance documentation",
    ],
  },
];

export const ENTITY_TYPES = ["Stock Broker", "Depository Participant", "Research Analyst", "Investment Adviser", "PMS", "AIF", "Other"];
